import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { LinkTextSecondaryMediumProps } from '../types/interfaces'

interface UseLinkTextSecondaryMediumOptions {
  props: LinkTextSecondaryMediumProps
}

interface UseLinkTextSecondaryMediumReturn {
  refIsBlankTarget: ComputedRef<boolean>
}

export const useLinkTextSecondaryMedium = ({ props }: UseLinkTextSecondaryMediumOptions): UseLinkTextSecondaryMediumReturn => {
  const refIsBlankTarget = computed<boolean>(() => props.target === '_blank')

  return {
    refIsBlankTarget,
  }
}
